module.exports = __webpack_public_path__ + "img/home.a3954523.svg";